export default __webpack_public_path__ + "static/media/mortis.fc27413f.png";